import theme from "@/theme";
import { Link, Stack, Typography } from "@mui/material";

export interface HereToHelpCardProps {
  title: string;
  description: string;
  button: {
    text: string;
    url: string;
    icon: React.ReactNode;
  };
}

export default function HereToHelpCard(
  props: HereToHelpCardProps
): JSX.Element {
  const {
    title,
    description,
    button: { text, url, icon },
  } = props;

  return (
    <>
      <Stack
        sx={{
          border: `1.5px solid ${theme.palette.primary[800]}`,
          borderRadius: 2,
          overflow: "hidden",
        }}
        width="100%"
      >
        <Stack
          sx={{
            backgroundColor: theme.palette.primary[800],
            padding: 2,
          }}
        >
          <Stack
            flexDirection="column"
            alignItems="center"
            justifyContent="space-between"
            gap={1}
          >
            <Typography
              fontWeight={600}
              variant="h3"
              sx={{
                fontWeight: 600,
                fontSize: 16,
                color: "white",
                lineHeight: 1.5,
              }}
            >
              {title}
            </Typography>

            <Typography
              variant="body2"
              sx={{
                textAlign: "center",
                fontSize: 14,
                fontWeight: 400,
                lineHeight: 1.5,
                color: "white",
              }}
            >
              {description}
            </Typography>
          </Stack>
        </Stack>

        <Link underline="none" href={url} aria-label={text}>
          <Stack
            mt={1.875}
            mb={1.875}
            gap={1.25}
            flexDirection="row"
            flexWrap="wrap"
            alignItems="center"
            justifyContent="center"
          >
            {icon}
            <Typography
              style={{
                textAlign: "center",
                fontSize: 15,
                fontWeight: 700,
                lineHeight: 1.25,
                color: theme.palette.primary[700],
              }}
            >
              {text}
            </Typography>
          </Stack>
        </Link>
      </Stack>
    </>
  );
}
